<template>
  <img alt="ofix logo" class="logo" height="47" src="/images/logo.svg" width="131" />
</template>

<script>
export default {
  name: 'Logo',
};
</script>

<style lang="scss">
.logo {
  max-width: 100%;
}
</style>
